import React from "react";
import { TooltipVariant } from "../IdlesTooltip";
import { TooltipGridCell, TooltipGridRow } from "@infobis/ui-styles-utils";
import st from "../IdlesTooltip.module.scss";
import cn from "classnames";
import { formatTime } from "@utils/format/time";
import {
    getConvertedPeriodAndExceedInfo
} from "@pages/dashboard/works/detalization/efficiency/IdlesChart/components/IdlesTooltip/utils/utils";

type IdlesTooltipFooterProps = {
    variant: TooltipVariant
    totalFact: number
    totalPlan: number
}

const RenderTooltipFooter = (props: IdlesTooltipFooterProps) => {
    const {
        variant,
        totalFact,
        totalPlan
    } = props;

    const contentCls = cn(st[`tooltip__text--common--${variant}`], st[`tooltip__text--naming--${variant}`])

    const { plan, isExceed, fact } = getConvertedPeriodAndExceedInfo(totalFact, totalPlan)

    return (
        <TooltipGridRow>
            <TooltipGridCell
                contentClassName={contentCls}
            >
                Итого:
            </TooltipGridCell>
            <TooltipGridCell
                contentClassName={cn(contentCls, isExceed && st[`tooltip__text--exceed--${variant}`])}
                align={'end'}
            >
                {formatTime(fact)}
            </TooltipGridCell>
            <TooltipGridCell
                contentClassName={contentCls}
                align={'end'}
            >
                {formatTime(plan)}
            </TooltipGridCell>
        </TooltipGridRow>
    )
}

export default RenderTooltipFooter;